import { type ReactNode } from "react"

const Modal = ({ children, open }: { children: ReactNode, open: boolean, }) => {
    return <div style={{ display: open ? "flex" : "none" }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl">
            {children}
        </div>
    </div>
}

export default Modal